import PropTypes from "prop-types";
import "./successCheckmark.css";

export default function SuccessCheckmark({ animate = false, pulse = false, onComplete }) {
  return (
    <span
      className={`success-checkmark${animate ? " is-animated" : ""}${pulse ? " is-pulsing" : ""}`}
      aria-hidden="true"
      onAnimationEnd={(event) => {
        if (event.animationName === "success-checkmark-ripple") onComplete?.();
      }}
    >
      <span className="success-checkmark-ripple" />
      <svg viewBox="0 0 96 96" fill="none" focusable="false">
        <circle className="success-checkmark-surface" cx="48" cy="48" r="40" />
        <circle className="success-checkmark-outline" cx="48" cy="48" r="40" pathLength="1" />
        <g className="success-checkmark-breath">
          <path className="success-checkmark-tick" d="M29 48 42 61 68 35" pathLength="1" />
        </g>
      </svg>
    </span>
  );
}

SuccessCheckmark.propTypes = {
  animate: PropTypes.bool,
  pulse: PropTypes.bool,
  onComplete: PropTypes.func,
};
